import { render } from "./inlineStyle.vue?vue&type=template&id=00647fc8"
import script from "./inlineStyle.vue?vue&type=script&lang=js"
export * from "./inlineStyle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__